import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import { mobileNoFormat, passwordFormat, textFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputPassword from "components/inputs/signUp/InputPassword";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { validateInputs } from "shared/utils/Utils";

function AdminStoreEdit() {
    const location = useLocation();
    const inputs = useRef([]);
    const searchRef = useRef();
    const selectRef = useRef();
    const { t } = useTranslation();

    const id = 'root';
    const dispatch = useDispatch();
    const [searchResults, setSearchResults] = useState();
    const [selectedVendorId, setSelectedVendorId] = useState();
    const [info, setInfo] = useState();
    /* 국내 주소 관련  */
    const [enroll_company, setEnroll_company] = useState({});
    /* 국내 주소 관련 끝 */
    const addressKrModalClick = () => {
        NiceModal.show("addressKr", { onCallback: addressKrCallback });
    }
    const addressKrCallback = (dataFromModal) => {
        const kakao = window.kakao;
        const geocoder = new kakao.maps.services.Geocoder();

        // 모달에서 받은 주소를 기반으로 좌표 검색
        geocoder.addressSearch(dataFromModal.address, function (result, status) {
            if (status === kakao.maps.services.Status.OK) {
                console.log(result);
                const { x, y } = result[0]; // 변환된 좌표
                console.log("좌표 변환 결과:", { x, y });

                // 좌표와 함께 info 상태 업데이트
                setInfo((prevInfo) => ({
                    ...prevInfo,
                    address: dataFromModal.address,
                    zonecode: dataFromModal.zonecode,
                    latitudeByX: x,
                    longitudeByY: y,
                }));

                // enroll_company도 업데이트
                setEnroll_company((prevState) => ({
                    ...prevState,
                    address: dataFromModal.address,
                    zonecode: dataFromModal.zonecode,
                }));
            } else {
                console.error("주소 변환 실패:", status);
            }
        });
    };
    useEffect(() => {
        if (location.state) {
            setInfo(location.state.data);

        }
    }, [location])
    useEffect(() => {
        if (info) {
            // setSearchResults(info.vendorStores);
            console.log(info);
            setSelectedVendorId(info.vendorStores[0].vendorId);
        }
    }, [info])
    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }
    const update = () => {
        let data = { id: info.id,storeName: "", storeCode: "", address: "", latitudeByX: "", longitudeByY: "" }
        validateInputs(inputs.current).then((isValid) => {
            if (isValid) {
                // 유효성 검사를 통과하면, 입력 필드로부터 값을 가져와 data 객체를 업데이트
                data.storeName = inputs.current[0].getValue();
                data.address = inputs.current[1].getValue();
                data.storeCode = inputs.current[2].getValue();

                data.latitudeByX = info.latitudeByX;
                data.longitudeByY = info.longitudeByY;
                console.log(data);
                requester.updateStore(data, (result) => {
                    console.log(result.data);
                })

            } else {
                toast.error(t("pleaseCheck"), {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });

            }
        })
        
    }


    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={20}>
                    <FlexChild>
                        <div>
                            <P size={40} font={"gmarketSansBold"} color={"black"}>스토어 수정</P>
                        </div>
                    </FlexChild>

                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>매장명 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText value={info?.storeName} ref={el => (inputs.current[0] = el)} placeHolder={"매장명"} regExp={[textFormat]} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>주소 : </P>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <InputText
                                            value={info && `${info?.address + (info.zonecode ? `(${info.zonecode})` : "")}` || `${enroll_company.address} (${enroll_company.zonecode})` || ""}
                                            ref={el => (inputs.current[1] = el)}
                                            placeHolder={"주소"}
                                        />
                                    </FlexChild>
                                    <FlexChild>
                                        <CustomButton text={"주소찾기"} style={btnStyle} onClick={addressKrModalClick} />
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>좌표 : </P>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex flexStart>
                                    <FlexChild>
                                        <Inline>
                                            <P>위도 : </P>
                                            <P>{info?.latitudeByX}</P>
                                        </Inline>
                                    </FlexChild>
                                    <FlexChild>
                                        <Inline>
                                            <P>경도 : </P>
                                            <P>{info?.longitudeByY}</P>
                                        </Inline>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상점 코드 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText value={info && info.storeCode} ref={el => (inputs.current[2] = el)} placeHolder={"상점코드"} regExp={[textFormat]} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <CustomButton text={"수정하기"} style={btnStyle} onClick={update} />
                    </FlexChild>
                </VerticalFlex>


            </Container>
        </Container>
    );
}

export default AdminStoreEdit;